function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { AppContext } from 'context';
import Link from 'components/Link';
import App from 'modules/App';
import Account from 'modules/Account';
import { NAV_ITEMS_ICONS } from '../../../../constants';
import messages from '../../../../messages';
import styles from './Nav.pcss';
const useUrlTo = (routing)=>{
    const { getUrl } = useContext(AppContext);
    if (!routing.routeName) {
        return '';
    }
    return getUrl(routing.routeName);
};
const NavItem = ({ routing })=>{
    const route = useSelector(App.selectors.route);
    const Icon = NAV_ITEMS_ICONS[routing.key];
    const to = useUrlTo(routing);
    return /*#__PURE__*/ _jsx("li", {
        className: cn(styles.sidebar__nav__list__item, styles[`sidebar__nav__list__item--${routing.key}`], {
            [styles['sidebar__nav__list__item--active']]: routing.routeName === route.name
        }),
        children: /*#__PURE__*/ _jsxs(Link, {
            to: to,
            children: [
                Icon && /*#__PURE__*/ _jsx(Icon, {
                    className: "mr-5"
                }),
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers[routing.key]))
            ]
        })
    });
};
const Nav = ()=>{
    const account = useSelector(Account.selectors.account);
    useStyles(styles);
    if (!account) {
        return null;
    }
    const { scope } = account;
    const routings = Account.constants.ROUTING_BY_SCOPE[scope];
    const renderNavItem = (routing)=>/*#__PURE__*/ _jsx(NavItem, {
            key: routing.key,
            routing
        });
    return /*#__PURE__*/ _jsx("nav", {
        className: `col ${styles.sidebar__nav}`,
        children: /*#__PURE__*/ _jsx("ul", {
            className: styles.sidebar__nav__list,
            children: routings.map(renderNavItem)
        })
    });
};
export default /*#__PURE__*/ memo(Nav);
